import { isDate } from "util";

cafm.web = {
    
    setClientSettings: function(cs){

        if (cs) {

            cafm.build = cs.build;
            cafm.auth.mode = cs.authMode;
            cafm.auth.loginPath = cs.loginPath;
            cafm.user = {
                prefs: cs.userPrefs
            }

            if (cs.onError) {

                window.onerror = (msg, url, line, colno, error) => {
                    try {
                        cafm.util.callFunction(cs.onError, msg, url, line, colno, error);
                    }
                    finally {
                        console.error(error);
                    }
                }
            }

            kendo.cultures.current.calendars.standard.patterns.d = cs.shortDatePattern;
            kendo.cultures.current.calendars.standard.patterns.D = cs.longDatePattern;
            kendo.cultures.current.calendars.standard.patterns.g = cs.dateTimePattern;
            kendo.cultures.current.calendars.standard.patterns.t = cs.shortTimePattern;
            kendo.cultures.current.calendars.standard.patterns.T = cs.longTimePattern;
            kendo.cultures.current.numberFormat.currency.decimals = cs.currencyDecimals;
            kendo.cultures.current.numberFormat.currency.symbol = cs.currencySymbol;
            kendo.cultures.current.numberFormat.currency.pattern = cs.currencyPattern;

            cs.baseApiUrl = cs.baseApiUrl.toLowerCase();
            cs.baseUrl = cs.baseUrl.toLowerCase();
            if (cs.baseUrl.endsWith('/')) cs.baseUrl = cs.baseUrl.substring(0, cs.baseUrl.length - 1);

            cafm.cache.set(cafm.res.consts.CacheKey_ClientSettings, cs);
        }
    },
    ready: function () {

        var cs = cafm.getClientSettings();
        this.checkBuildHash(cs);
        this.setClientSettings(cs);

        //For window.open with target _Blank, session cafm.res.consts.CacheKey_TimeZone is lost as new Tab is new Session. This is the best conservative fix I can think of!
        let sessionStoreTZ = cafm.cache.session.get(cafm.res.consts.CacheKey_TimeZone);
        if (!sessionStoreTZ) {
            let localStoreTZ = cafm.cache.get(cafm.res.consts.CacheKey_LastTimeZoneSelection);
            if (localStoreTZ) //So that in Windows Mode, we still prompt for TZ Or come up with more solid solution!
            {
                cafm.cache.session.set(cafm.res.consts.CacheKey_TimeZone, localStoreTZ);
            }
        }

        if (cs.cachedApplicationToDesktop) {

            window.location.reload(true);
        }

        if (!cafm.cache.isAvailable()) {

            cs.offlineEnabled = false;
            cafm.cache.set(cafm.res.consts.CacheKey_ClientSettings, cs);
        }
        
        // ensure security
        if (!cs.isAuthenticated && cafm.url.isAuthenticatedUrl()) {

            cafm.auth.notAuthenticated(true);
        }

        this.keepAlive.start();

        window.addEventListener("message", cafm.web.handlers.postMessage, false);

        body.on('click.cafmglobal', 'button', e => {

            let btn = $(e.currentTarget);
            switch (btn.data('key')) {
                case 'Cancel':
                    var parent = btn.closest('.k-tooltip');
                    if (parent.length) parent.find('.k-tooltip-button').click();
                    break;
                case 'Close':
                    var parent = btn.closest('#rightCol');
                    if (parent.length) cafm.layout.hideRightColumn();
                    else if (btn.closest(`.${cafm.res.consts.CssClass_WindowButtons}`).length && !btn.closest(".msgWindow").length) cafm.views.closeActionWindow();
                    break;
            }
        });

        if (cafm.isOfflineEnabled())
        {
            cafm.offline.registerServiceWorker();
        }
    },
    load: function () {

        cafm.web.funcs.setupTopSearchText();

        if (!window.isMobile) window.isMobile = cafm.isMobile();
                
        // validate client time
        cafm.web.funcs.validateClientTime();
    },
    checkBuildHash: function (cs) {
        
        var cachedBuildHash = cafm.cache.get(cafm.res.consts.CacheKey_BuildHash);
        var prefix = '='; // use a prefix to ensure the hash is always treated as a string
        //console.log('cachedBuildHash: {0}'.format(cachedBuildHash));
        //console.log('cs.build: {0}'.format(prefix + cs.build));

        if (cachedBuildHash != (prefix + cs.build)) {

            console.log('New build version detected.');
            window.localStorage.clear();
            window.sessionStorage.clear();
        }

        if (!cafm.cache.exists(cafm.res.consts.CacheKey_BuildHash)) {

            cafm.cache.set(cafm.res.consts.CacheKey_BuildHash, prefix + cs.build);
        }
    },
    onUserLoggedIn: function (redirecting, clearCache) {

        if (clearCache) {

            cafm.cache.clearAll([
                cafm.res.consts.CacheKey_BuildHash,
                cafm.res.consts.CacheKey_LoginInfo,
                cafm.res.consts.CacheKey_PasswordExpired,
                cafm.res.consts.CacheKey_PasswordTooSimple,
                cafm.res.consts.CacheKey_PublicCalendarCriteria
            ]);
        }

        if (!redirecting) {

            cafm.ajaxEnd.push(cafm.web.funcs.showTopSearch);
        }
    },
    getAppListContainer: function () {

        return $('#mainContentPane .appListContainer');
    },
    keepAlive: {

        start: function () {
            var cs = cafm.getClientSettings();

            cafm.web.keepAlive.updateLastServerActivity();
            cafm.web.keepAlive.run(cs, true);
        },
        run: function (cs, start) {
            
            try {

                if ((this.getLastServerActivity() <= (cafm.util.getTime() - cafm.res.consts.Var_ClientRefreshTimeout)) || (start && cs.offlineEnabled)) {

                    cafm.actions.execute({
                        id: 'refreshClientContext',
                        url: cafm.url.get(cafm.res.consts.Url_RefreshClient),
                        suppressErrors: false,
                        statusCodeFuncs: {

                            200: function (r, s, m, a) {

                                cafm.web.keepAlive.updateLastServerActivity();

                                if (cs.offlineEnabled) {

                                    cafm.setOffline(false);
                                }
                            }
                        },
                        error: function () {

                            console.error('error on keep alive')

                            if (cs.offlineEnabled) {

                                cafm.setOffline(true);
                            }
                        }
                    });
                }
            }
            catch (err) {
                console.log('keep alive action error: {0}'.format(err.message))
            }
            
            setTimeout(function () {

                cafm.web.keepAlive.run(cs);
            }, cafm.res.consts.Var_ClientRefreshTimeout + 250);
        },
        getLastServerActivity: function () {

            var lastServerActivity = cafm.cache.session.get(cafm.res.consts.CacheKey_LastServerActivity);

            if (!lastServerActivity) {

                lastServerActivity = cafm.util.getTime();
            }

            return lastServerActivity;
        },
        updateLastServerActivity: function () {

            cafm.cache.session.set(cafm.res.consts.CacheKey_LastServerActivity, cafm.util.getTime());
        }
    },
    onError: function (msg, url, line) {

        try {

            cafm.msg.showMessageInWindow({
                type: cafm.enums.MessageType.Error,
                title: 'Unhandled script error',
                html: 'Error message: {0}<hr/>URL: {1}<br/>Line: {2}'.format(msg, url, line),
                closeOnClick: false
            });
        }
        catch (err) {

            alert('Unhandled Script error. Error message: {0} ~ URL: {1} ~ Line: {2}'.format(msg, url, line));
        }
        return true;
    },
    funcs: {

        setupTopSearchText: function () {

            var st = $('#searchText');
            st.focus(() => {
                st.addClass('searchFocused');
            }).blur(() => {
                if (!st.textVal().trim())
                    st.removeClass('searchFocused');
            });

            st.enterPressed(function (e) {

                cafm.web.funcs.setTopSearchText(st.textVal().trim());

                if (cafm.handlers.exists('cafm.search')) {

                    cafm.handlers.exe('cafm.search', {

                        textbox: st,
                        event: e
                    });
                }
                else {

                    if (st.data('helpdesk')) {

                        cafm.hd.topLevelSearch();
                    }
                    else if (st.data('property')) {

                        cafm.prop.topLevelSearch();
                    }
                    else if (st.data('assets')) {

                        cafm.assets.topLevelSearch();

                    }
                }

                return false;
            });

            st.show();
        },
        getTopSearchText: function () {

            var st = cafm.cache.session.get(cafm.res.consts.CacheKey_TopSearchText);

            // workaround - replace any starting * as that doesn't route
            if (isStr(st) && st.startsWith('*')) st = st.replace('*', '_*_');

            return st;
        },
        setTopSearchText: function (text) {

            cafm.cache.session.set(cafm.res.consts.CacheKey_TopSearchText, text);
        },
        removeTopSearchText: function () {

            cafm.cache.session.remove(cafm.res.consts.CacheKey_TopSearchText);
        },
        isTopSearch: function () {

            var isTopSearch = cafm.cache.session.exists(cafm.res.consts.CacheKey_TopSearchText);
            if (isTopSearch) {

                cafm.cache.session.remove(cafm.res.consts.CacheKey_TopSearchText);
            }
            return isTopSearch;
        },
        showTopSearch: function () {

            $('#headerRight').loadView({

                url: cafm.url.get('~/Default/SearchBox'),
                onLoad: function () {

                    cafm.web.funcs.setupTopSearchText();
                }
            });
        },
        placeNavMenu: function () {

            var targ = isMobile ? $('#mobileMenu') : $('.context-container').first();

            var children = $('.k-treeview', targ);
            if(children.length){
                kendo.destroy(children.not(''));
            }
            children.remove();

            var nt = nav.getNavTree();
            if (isMobile) {
                targ.append(nt);
            }
            else {
                targ.append(nt);
            }
        },
        validateClientTime: function () {
            
            if (cafm.getClientSettings().offlineEnabled) {

                var hasWarned = cafm.cache.session.get(cafm.res.consts.CacheKey_DeviceTimeWarning);

                if (!hasWarned) {

                    var reqMillis = cafm.util.getTime();
                    cafm.web.funcs.getServerTime({

                        handler: function (serverMillis) {

                            if (serverMillis > 0) {

                                // the following takes the request/response diff from the server time to ensure accuracy
                                var resMillis = cafm.util.getTime();
                                var reqDiff = resMillis - reqMillis;
                                var clientMillis = resMillis - reqDiff;

                                // if client time is ahead of the server time warn the user 
                                if (clientMillis > serverMillis) {
                                                                        
                                    if (parseInt(clientMillis - serverMillis) > 30000) {

                                        cafm.msg.showMessageInWindow({

                                            title: cafm.res.str.MessageDeviceTimeWarning,
                                            type: cafm.enums.MessageType.Warning
                                        });
                                    }
                                }
                            }
                        }
                    });
                }
                
                cafm.cache.session.set(cafm.res.consts.CacheKey_DeviceTimeWarning, true);
            }
        },
        getServerTime: function(args) {
            
            var result;
            var id = 'GetServerTime';

            var getServerTimeAction = cafm.actions.get(id);

            if (!getServerTimeAction) {

                getServerTimeAction = cafm.actions.add(new cafm.actions.Action({
                    id: id,
                    url: cafm.url.api('WebApp/GetServerTime'),
                    method: 'GET',
                    requestDelay: 0,
                    sync: args.sync,
                    suppressErrors: true,
                    statusCodeFuncs: {

                        200: function (serverMillis) {

                            if (isNum(serverMillis)) {

                                result = serverMillis;

                                if (isFunc(args.handler)) {

                                    args.handler(serverMillis);
                                }
                            }
                        }
                    },
                    fallback: args.fallback
                }));
            }

            getServerTimeAction.execute();

            if (args.sync) {

                return result;
            }
        },
        /**
         * Returns current session Date object
         * */
        getSessionDateTimeNow: function () {
            var nowUtc = cafm.isOffline() ? moment.utc() : cafm.web.funcs.getNowUTC();
            return cafm.web.funcs.fromUTCToSessionDateTime(nowUtc, true);
        },
        /**
         * Returns current session Date Time  in 'DD/MM/YYYY hh:mm A' format
         * */
        getSessionDateTimeNowText: function () {
            var d = cafm.web.funcs.getSessionDateTimeNow();
            return moment(d).format('DD/MM/YYYY hh:mm A');
        },
        /**
         Returns current UTC datetime as JS Date object
         * @param {any} args
         */
        getNowUTCAsDateTime: function (args) {
            return cafm.web.funcs.getNowUTCAsMomentDate(args).toDate();
        },
        /**
         Returns current UTC datetime in 'YYYY-MM-DDTHH:mm:ss' format
         * @param {any} args
         */
        getNowUTC: function (args)
        {
            var dt = cafm.web.funcs.getNowUTCAsMomentDate(args);
            return dt.format("YYYY-MM-DDTHH:mm:ss.0") + "Z";
        },
        /**
         Returns current UTC datetime as Moment DateTime object
         * @param {any} args
         */
        getNowUTCAsMomentDate: function (args) {
            var millis = cafm.web.funcs.getServerTime({ sync: true });

            var dt;//moment

            if (millis) {
                dt = moment.utc(millis);
            } else {
                if (cafm.getClientSettings().offlineEnabled) {
                    cafm.setOffline(true);
                }
                dt = moment().utc();
            }
            if (args && args.truncateToMinutes) {
                dt.set({ second: 0, millisecond: 0 });
            }
            return dt;
            
        },
        fromSessionToUTCDateTime: function (dt, truncToMin, tzName = cafm.cache.session.get(cafm.res.consts.CacheKey_TimeZone))
        {
            //In an ideal world, this function should only be called from within a DateTime picker control
            if (dt) {
                var fmt = isMobile ? "YYYY-MM-DDTHH:mm:ss" : "YYYY-MM-DD HH:mm:ss";
                var momInStr = moment(dt).format(fmt);
                var m = moment.tz(momInStr, fmt, tzName);
                m.utc();
                return new Date(m.year(), m.month(), m.date(), m.hours(), m.minutes(), truncToMin ? 0 : m.seconds(), 0);
            } else {
                return null;
            }
        },
        fromUTCToSessionDateTime(dt) {
            if (dt) {
                if (isDate(dt)) {//Remove the TimeZone component from JS date object
                    var offset = dt.getTimezoneOffset();
                    if (offset > 0) { dt = dt.setTime(dt.getTime() + offset * 60000) };
                    if (offset < 0) { dt = dt.setTime(dt.getTime() - offset * 60000) };
                }
                var m = moment.utc(dt);
                var sessionTimeZone = cafm.cache.session.get(cafm.res.consts.CacheKey_TimeZone);
                if (sessionTimeZone) {
                    m = m.tz(sessionTimeZone);
                }
                return new Date(m.year(), m.month(), m.date(), m.hours(), m.minutes(), 0, 0);
            } else {
                return null;
            }
        },
        fromUTCToSessionDateOnly(dt) {

            if (dt) {
                if (isDate(dt)) {//Remove the TimeZone component from JS date object
                    var offset = dt.getTimezoneOffset();
                    if (offset > 0) { dt = dt.setTime(dt.getTime() + offset * 60000) };
                    if (offset < 0) { dt = dt.setTime(dt.getTime() - offset * 60000) };
                }
                var m = moment.utc(dt);
                var sessionTimeZone = cafm.cache.session.get(cafm.res.consts.CacheKey_TimeZone);
                if (sessionTimeZone) {
                    m = m.tz(sessionTimeZone);
                }
                return new Date(m.year(), m.month(), m.date(), 0, 0, 0, 0);
            } else {
                return null;
            }
        },
        setCookie() {
            // clear cookies first to ensure single values
            cafm.dom.clearCookie(cafm.res.consts.Cookie_CafmModule);
            cafm.dom.clearCookie(cafm.res.consts.Cookie_CafmTask);
            cafm.dom.clearCookie(cafm.res.consts.Cookie_CafmId);
            cafm.dom.clearCookie(cafm.res.consts.Cookie_CafmExcludeIds);

            let module = cafm.getCurrentModule(),
                cookie = {};
            if (!isNullOrUndefined(module)) {
                cookie[cafm.res.consts.Cookie_CafmModule] = module;
            }
            if (cafm.nav.navigatable) {
                cookie[cafm.res.consts.Cookie_CafmTask] = cafm.nav.navigatable;
            }
            if (cafm.actions.objectInContextId) {
                cookie[cafm.res.consts.Cookie_CafmId] = cafm.actions.objectInContextId;
            }
            cafm.dom.setCookie({ data: cookie });
        },
        setRequestExcludeIds(args) {
            // get the associate datasource
            let assDataSource = args.dataSource;
            if (assDataSource && cafm.util.hasItem(assDataSource.data())) {
                // set exclude ids from associate datasource
                let ids = cafm.util.transformArray(assDataSource.data(), function (dataItem) {

                    // return the ID
                    return cafm.util.getReference(args.idField, dataItem);
                });
                // set exclude IDs request header    
                let setCookieVals = {};
                setCookieVals[cafm.res.consts.Cookie_CafmExcludeIds] = ids.join(cafm.res.consts.Var_HeaderValuesSeparator);
                cafm.dom.setCookie({ data: setCookieVals });
            }
        }
    },
    handlers: {
        postMessage(event) {
            if (event.origin !== cafm.url.currentOrigin())
                return;
            if (event.data && event.data.command === "FrameLogin") {
                cafm.auth.notAuthenticated();
            }
        },
        backBtnHandle: function(e) {

            var k = 'cafm.back';
            if (cafm.handlers.exists(k)) {
                cafm.handlers.exe(k, e);
            }
            else {
                cafm.url.set(); // go to default/home page
            }
            cafm.views.closeActionWindows();

            if (isMobile) {

                cafm.views.closeActionWindows();
                $('#main').show();
            }
        },
        userMenuBtnHandle: function(e){

            $('#mobileUserMenu').toggle();
        }
    },
    closeWindow: function () {
        window.close();
    }
}